import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "description"]
  static values = { descriptions: Object }

  connect() {
    this.update()
  }

  update() {
    const id = this.selectTarget.value
    const text = this.descriptionsValue[id] || ""
    // A slot inside the target lets the view keep a label ("Program description:") next
    // to the text; without one, the target itself takes the text.
    const slot = this.descriptionTarget.querySelector("[data-program-description-slot]") || this.descriptionTarget
    slot.textContent = text
    this.descriptionTarget.classList.toggle("d-none", !text)
  }
}
